(() => {
  'use strict';
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  const key = 'facts_language_choice';
  const supported = ['de', 'en'];
  const suggestion = document.getElementById('FactsLanguageSuggestion');
  const publicPath = /^\/(?:pages|products|collections|policies|blogs|search|cart|account)(?:\/|$)/;
  const excludedPath = /^\/(?:en\/)?(?:account|customer_authentication|checkout|checkouts|tools|challenge)(?:\/|$)/;
  const ownedHosts = new Set([location.hostname, 'factssystem.com', 'www.factssystem.com', 'factsandsupps.com', 'www.factsandsupps.com']);

  function preference() {
    try {
      const value = document.cookie.split('; ').find(part => part.startsWith(key + '='));
      const choice = value && value.slice(key.length + 1);
      return supported.includes(choice) ? choice : null;
    } catch { return null; }
  }

  function remember(choice) {
    if (!supported.includes(choice)) return;
    try { document.cookie = key + '=' + choice + '; Path=/; Max-Age=15552000; SameSite=Lax; Secure'; } catch {}
    if (suggestion) suggestion.hidden = true;
  }

  function localizationForm(element) {
    const form = element && element.closest('form');
    if (!form) return null;
    try {
      const url = new URL(form.action, location.href);
      return url.origin === location.origin && /\/localization\/?$/.test(url.pathname) ? form : null;
    } catch { return null; }
  }

  function retainLanguage(link) {
    if (locale !== 'en' || !link || link.hasAttribute('hreflang') || link.hasAttribute('download') || link.hasAttribute('data-facts-language-exempt') || localizationForm(link)) return;
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    try {
      const url = new URL(raw, location.href);
      if (!/^https?:$/.test(url.protocol) || !ownedHosts.has(url.hostname) || !publicPath.test(url.pathname)) return;
      url.pathname = '/en' + url.pathname;
      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch {}
  }

  function rememberForm(form) {
    const input = form && form.querySelector('[name="language_code"], [name="locale_code"]');
    if (input) remember(input.value);
    const returnTo = form && form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  }

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const form = localizationForm(target);
    if (form) {
      const option = target.closest('[data-value], [data-locale]');
      if (option) {
        rememberForm(form);
        remember(option.getAttribute('data-value') || option.getAttribute('data-locale'));
      }
      if (target.closest('button[type="submit"], input[type="submit"]')) rememberForm(form);
    }
    retainLanguage(target.closest('a[href]'));
  }, true);
  document.addEventListener('auxclick', event => {
    if (event.target instanceof Element) retainLanguage(event.target.closest('a[href]'));
  }, true);
  document.addEventListener('submit', event => rememberForm(localizationForm(event.target)), true);
  document.addEventListener('change', event => {
    const form = localizationForm(event.target);
    if (form && /^(language_code|locale_code)$/.test(event.target.name)) rememberForm(form);
  }, true);
  document.querySelectorAll('a[href]').forEach(retainLanguage);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('a[href]').forEach(retainLanguage));

  if (!suggestion || suggestion.dataset.designMode === 'true' || excludedPath.test(location.pathname) || new URLSearchParams(location.search).has('view')) return;
  const dismiss = suggestion.querySelector('[data-facts-language-dismiss]');
  dismiss.addEventListener('click', () => remember('de'));
  const browsers = Array.from(navigator.languages || [navigator.language]).map(value => String(value).toLowerCase().split('-')[0]);
  if (preference() || browsers.some(value => supported.includes(value)) || !browsers.some(Boolean)) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const root = suggestion.dataset.root.replace(/\/$/, '') + '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {signal:controller.signal, credentials:'same-origin', headers:{Accept:'application/json'}})
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country) || ['DE', 'AT', 'CH'].includes(country) || preference()) return;
      suggestion.hidden = false;
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
